import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer, { RootState } from './reducers';
import { createEpicMiddleware } from 'redux-observable';
import epics from './epics';
import trimFields from './trimFields';

const isDevelopmentEnv = process.env.NODE_ENV.startsWith('development');

const epicMiddleware = createEpicMiddleware();
const defaultMiddleware = [thunk, epicMiddleware, trimFields];

export default function configureStore(initialState?: Partial<RootState>, middleware: any[] = []) {
  const composeEnhancers = (isDevelopmentEnv && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...defaultMiddleware, ...middleware))
  );

  epicMiddleware.run(epics);

  if (module.hot) {
    module.hot.accept('./reducers', async () => {
      const { default: nextRootReducer } = await import('./reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
